

// function createJanusConnection () {
(function (window, document) {
  
var con

function createJanusConnection () {
  let con = null

  let state = {
    video: {
      src: null
    },
    connectionFailed: false,
    host: null,
    stream: null,
    pin: null
  }

  let _session = {
    id: 0,
    handleId: 0,
    iceCandidateCount: 0,
    tx: null,
    sessionState: 'initial',
    region: null
  }

  function onSocketMessageReceived (m) {
    if (m.transaction === _session.tx) {
      if (_session.sessionState === 'initial') {
        _session.sessionState = 'create-session'
        onSessionCreated(m)
      } else if (_session.sessionState === 'create-session') {
        _session.sessionState = 'attach-plugin'
        onAttachedPlugin(m)
      } else if (_session.sessionState === 'attach-plugin') {
        _session.sessionState = 'receive-stream-list'
        onReceivedStreamList(m)
      } else if (_session.sessionState === 'receive-stream-list') {
        onWatchCommandResponse(m)
      }
    } else {
      if (m.janus === 'webrtcup') {
        onWebRtcUp(m)
      }
    }
  }

  function sendSocketKeepAlive () {
    let tx = randAlphaNum(12)
    let body = {
      janus: 'keepalive',
      session_id: _session.id,
      transaction: tx
    }

    con.send(body)

    setTimeout(() => {
      if (!state.connectionFailed) {
        sendSocketKeepAlive()
      }
    }, 45000)
  }

  function onSessionCreated (m) {
    // console.log('onSessionCreated')
    _session.id = m.data.id
    sendSocketKeepAlive()
    _session.tx = randAlphaNum(12)
    let body = {
      janus: 'attach',
      session_id: _session.id,
      transaction: _session.tx,
      'force-bundle': true,
      'force-rtcp-mux': true,
      plugin: 'janus.plugin.streaming'
    }

    con.send(body)
  }

  function onAttachedPlugin (m) {
    // console.log('onAttachedPlugin')
    _session.handleId = m.data.id
    // let's get a list of the streams on the server
    _session.tx = randAlphaNum(12)
    let body = {
      janus: 'message',
      transaction: _session.tx,
      session_id: _session.id,
      handle_id: _session.handleId,
      body: {
        request: 'list'
      }
    }
    con.send(body)
  }

  function onReceivedStreamList (m) {
    // console.log('onReceivedStreamList')
    if (m.plugindata.data.list.length === 0) {
      console.log('no streams found')
      return
    }

    let stream = null
    if (state.stream) {
      stream = m.plugindata.data.list.find(n => n.id === state.stream)
    }

    if (!stream) {
      console.log('stream not found')
      return
    }

    // let's watch the first stream. Setup an RTCPeerConnection.
    let iceServers = []

    // Add the google STUN-only server, more reliable than our TURN servers,
    // most of our types of connections will not require TURN servers, and if
    // we end up requiring a TURN server, it's not likely to be a good experience anyway.
    iceServers.push({ urls: 'stun:stun.l.google.com:19302' })

    // stun and turn
    // iceServers.push(turn1)
    // iceServers.push(turn2)
    _session.peerConn = new RTCPeerConnection({
      iceServers: iceServers
    })

    _session.peerConn.onicecandidate = (evt) => {
      onICECandidateReceived(evt)
    }

    _session.peerConn.ontrack = (evt) => {
      state.video.src = evt.streams[0]
    }

    // send the watch command to Janus
    _session.tx = randAlphaNum(12)
    let body = {
      janus: 'message',
      transaction: _session.tx,
      session_id: _session.id,
      handle_id: _session.handleId,
      body: {
        id: stream.id,
        request: 'watch'
      }
    }

    if (state.pin) {
      // This has to only be set if it has a value
      body.body.pin = state.pin
    }
    con.send(body)
  }

  function onICECandidateReceived (evt) {
    // console.log('onIceCandidate', evt.candidate)

    if (evt.candidate === undefined || evt.candidate == null) {
      // No more candidates coming in, so let Janus know we're done
      // console.log('No more candidates')
      if (_session.iceCandidateCount < 1) {
        console.error('No ICE candidates received!')
        setConnectionFailed()
        return
      }
      let tx = randAlphaNum(12)
      let body = {
        janus: 'trickle',
        transaction: tx,
        session_id: _session.id,
        handle_id: _session.handleId,
        candidate: {
          completed: true
        }
      }
      con.send(body)
      return
    }

    _session.iceCandidateCount++
    // send it to Janus
    let tx = randAlphaNum(12)
    let body = {
      janus: 'trickle',
      transaction: tx,
      session_id: _session.id,
      handle_id: _session.handleId,
      candidate: {
        candidate: evt.candidate.candidate,
        sdpMid: evt.candidate.sdpMid,
        sdpMLineIndex: evt.candidate.sdpMLineIndex
      }
    }
    con.send(body)
  }

  function onWatchCommandResponse (m) {
    // console.log('onWatchCommandResponse')
    if (m.janus === 'ack') {
      // we want to wait for the first 'event' message, which will contain the sdp info
      return
    }

    // We don't change state until we receive something after the ack
    _session.sessionState = 'main-tx-done'

    if (!_session.peerConn) {
      // console.log('null peerCon')
      setConnectionFailed()
      return
    }

    // console.log('remote sdp', m.jsep.sdp)
    _session.peerConn.setRemoteDescription(m.jsep).then(() => {
      // console.log('Successfully set the remote description')
    }).catch((err) => {
      console.error('Failed to set the remote description', err)
    })

    _session.peerConn.createAnswer().then((sdp) => {
      onAnswerCreated(sdp)
    }).catch((err) => {
      console.error('Failed to create answer', err)
      setConnectionFailed()
    })
  }

  function onAnswerCreated (sdp) {
    // console.log('onAnswerCreated')
    if (!_session.peerConn) {
      // console.log('null peerConn')
      setConnectionFailed()
    }

    // console.log('local sdp', sdp.sdp)
    _session.peerConn.setLocalDescription(sdp).then(() => {
      onSetLocalDescriptionCompleted()
    }).catch((err) => {
      console.error('Failed to set local description', err)
      setConnectionFailed()
    })
  }

  function onSetLocalDescriptionCompleted () {
    // console.log('onSetLocalDescriptionCompleted')
    if (!_session.peerConn) {
      // console.log('null peerCon')
      setConnectionFailed()
      return
    }

    if (!_session.peerConn.localDescription) {
      // console.log('null localDescription')
      setConnectionFailed()
      return
    }

    _session.tx = randAlphaNum(12)
    let body = {
      janus: 'message',
      transaction: _session.tx,
      session_id: _session.id,
      handle_id: _session.handleId,
      body: {
        request: 'start'
      },
      jsep: {
        sdp: _session.peerConn.localDescription.sdp,
        type: _session.peerConn.localDescription.type
      }
    }
    con.send(body)
  }

  function onWebRtcUp (session, message) {
    // console.log('onwebrtcup')
  }

  function clearConnectionInfo () {
    state.connectionFailed = false
    state.video.src = null
  }

  function onSocketReconnect () {
    clearConnectionInfo()
    startViewing()
  }

  function startViewing () {
    _session.sessionState = 'initial'
    _session.tx = randAlphaNum(12)
    _session.id = 0
    _session.handleId = 0
    _session.iceCandidateCount = 0
    let body = {
      janus: 'create',
      transaction: _session.tx
    }
    con.send(body)
  }

  function startSocketConnection (host, stream, pin) {
    console.log("startSocketConnection", host, stream, pin);
    let socketScheme = 'wss';

  //  if (process.env.VUE_APP_API_PROTO === 'http') {
  //    socketScheme = 'ws' // For debugging
  //  }

    if (stream) {
      state.stream = stream
    }

    state.pin = null
    if (pin) {
      state.pin = pin
    }

    state.host = host
    // let hostWithoutPort = host.split(':')[0]
    // let apiSockets = socketScheme + '://' + hostWithoutPort + '/ctrl-webrtc'
    let apiSockets = socketScheme + '://' + host + '/ctrl-webrtc'

    // Janus sockets
    // sockets.start(apiSockets, onSocketMessageReceived, onSocketReconnect)
    con = newConnection({
      protocol: 'janus-protocol',
      addr: apiSockets,
      onMsgReceived: onSocketMessageReceived,
      onReconnect: onSocketReconnect,
      onConnectStarting: null
    })
    con.start()
  }

  function stopSocketConnection () {
    if (con) {
      con.stop()
    }
    state.video.src = null
    setConnectionFailed()
  }

  function randAlphaNum (len) {
    let charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let str = ''
    for (let i = 0; i < len; i++) {
      let pos = Math.floor(Math.random() * charSet.length)
      str += charSet.substring(pos, pos + 1)
    }
    return str
  }

  function setConnectionFailed () {
    state.connectionFailed = true
    state.video.src = null
    if (_session.peerConn) {
      _session.peerConn.close()
      _session.peerConn = null
    }
  }

  return {
    startSocketConnection,
    stopSocketConnection,
    setConnectionFailed,
    state
  }
}

window.createJanusConnection = createJanusConnection;
   

})(window, document);

//export default {
//  createJanusConnection
//}
